import React from 'react';

import { clsx } from '@wego/alexis/helpers/clsx';

import styles from './PillToggle.module.scss';

export interface PillToggleItem {
  selected?: boolean;
  label: string;
  onClick?: () => void;
}

export interface PillToggleProps {
  items: PillToggleItem[];
  className?: string;
  onClick?: () => void;
}

const PillToggle: React.FC<PillToggleProps> = ({ items, className, onClick }) => {
  return (
    <div className={clsx(styles.container, className)} onClick={onClick}>
      {items.map((item) => (
        <div
          key={item.label}
          className={clsx(styles.option, item.selected && styles.selected)}
          onClick={item.onClick}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default PillToggle;
